define([], function() {
    return function() {
        return new Date().valueOf();
    };
});
